import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core';
import { CONFIG } from 'constants/config';
import { getTenantFromLocalStorage } from 'api/tenant';
import { VisualizacaoContext } from '../Context';

const useStyles = makeStyles(({
  pdf: {
    height: '100vh',
  },
}));

function Display() {
  const classes = useStyles();
  const { codigoConsulta } = useContext(VisualizacaoContext);
  const currentTenant = getTenantFromLocalStorage();

  return codigoConsulta && (
    <embed
      className={classes.pdf}
      src={`${CONFIG.api.replace('TENANT_ID', currentTenant)}/service-docs/v1/certificados/publico/documento/${codigoConsulta}`}
      type="application/pdf"
      width="100%"
    />
  );
}

export default Display;
